import React from 'react';
import { Grid, Box, Typography, Paper } from '@mui/material';
import PropTypes from 'prop-types';
import config from '../../../constants/config';

/**
 * @description Header component with location logo and name
 */
const PaymentHeader = ({ location, banner, locationImageUrl }) => {
  const logoSrc = locationImageUrl || `${config.APPURL}/assets/images/logo.png`;

  return (
    <Grid position={'relative'} container alignItems="center" sx={{ mb: 3 }}>
      <Grid item container xs={12} sm={3}>
        <Box
          component="img"
          src={logoSrc}
          alt="Company Logo"
          alignItems={'center'}
          sx={{ maxWidth: '100%', maxHeight: 80, objectFit: 'contain' }}
        />
      </Grid>
      <Typography
        textAlign={'center'}
        variant="h5"
        sx={{
          transform: { xs: 'translate(0, 0)', sm: 'translate(-50%, -50%)' },
          position: { xs: 'static', sm: 'absolute' },
          left: { xs: '0', sm: '50%' },
          top: { xs: '0', sm: '50%' },
          width: { xs: '100%', sm: 'auto' },
        }}
        fontWeight="bold"
      >
        {location?.locationName || ''}
      </Typography>
      {banner && (
        <Grid item xs={12}>
          <Paper sx={{ p: 2, bgcolor: 'info.light' }}>
            <Typography>{banner}</Typography>
          </Paper>
        </Grid>
      )}
    </Grid>
  );
};

PaymentHeader.propTypes = {
  location: PropTypes.shape({
    locationName: PropTypes.string,
    image: PropTypes.string,
  }),
  banner: PropTypes.string,
  locationImageUrl: PropTypes.string,
};

export default PaymentHeader;
